
export default {
  props: ['curso', 'activerCurso', 'panel', 'loaded', 'modalPreco'],
  computed: {
    preco: (v) =>
      v.curso?.investimento?.filter(
        (c) => c?.forma && c?.forma === 'cartão'
      )[0],
  },
}
